function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import Markdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeMathjax from 'rehype-mathjax';
import { Code, Editor } from '@deephaven/console';
import { jsx as _jsx } from "react/jsx-runtime";
var renderMarkdown = props => {
  var children = props.children,
    inline = props.inline,
    className = props.className;
  if (inline === true) {
    return /*#__PURE__*/_jsx("code", {
      children: React.Children.map(children, child => typeof child === 'string' ? child.trim() : child)
    });
  }
  var language = className !== undefined && className !== null && className !== void 0 && className.startsWith('language-') ? className.substring(9) : 'plaintext';
  return /*#__PURE__*/_jsx("pre", {
    children: /*#__PURE__*/_jsx("code", {
      children: /*#__PURE__*/_jsx(Code, {
        language: language,
        children: React.Children.map(children, child => typeof child === 'string' ? child.trim() : child)
      })
    })
  });
};
export default class MarkdownEditor extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "container", void 0);
    this.container = null;
  }
  render() {
    var _this$props = this.props,
      isEditing = _this$props.isEditing,
      content = _this$props.content,
      onEditorInitialized = _this$props.onEditorInitialized;
    return /*#__PURE__*/_jsx("div", {
      className: "markdown-editor-container",
      ref: container => {
        this.container = container;
      },
      children: isEditing ? /*#__PURE__*/_jsx(Editor, {
        settings: {
          language: 'markdown',
          value: content,
          lineNumbers: 'off'
        },
        onEditorInitialized: onEditorInitialized
      }) : /*#__PURE__*/_jsx(Markdown, {
        components: {
          code: renderMarkdown
        },
        remarkPlugins: [remarkMath],
        rehypePlugins: [rehypeMathjax],
        children: content
      })
    });
  }
}
_defineProperty(MarkdownEditor, "defaultProps", {
  isEditing: false,
  content: ''
});
//# sourceMappingURL=MarkdownEditor.js.map